import LayoutBasic from "@/views/layouts/LayoutBasic";
import OnlineStatus2 from "@/views/online/Status2";
import uploadsDeals from "@/views/uploads/deals";
import uploadsBlackList from "@/views/uploads/blackList";
import ReceiptTemplates from "@/views/admin/receipts/ReceiptTemplates";
import CreateReceipt from "@/views/admin/receipts/createReceipt";
import ReceiptsStatistics from "@/views/admin/receipts/receiptsStatistics";
import Home from "@/views/front/Home";
import BrowserError from "@/views/errors/browser";
import ManageBlackList from "@/views/uploads/ManageBlackList";

const routes = [
  {
    path: '/',
    component: LayoutBasic, // Change the desired Layout here
    meta: {requiresAuth: true},
    children: [
      {
        path: '/',
        component: Home,
        name: 'home',
        meta: {
          permission: true
        }
      },
    ]
  },
  {
    path: '/online',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: '/',
        component: OnlineStatus2,
        name: 'OnlineStatus',
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'online/status'
        }
      },
    ]
  },
  {
    path: '/uploads',
    component: LayoutBasic, // Change the desired Layout here
    meta: {requiresAuth: true},
    children: [
      {
        path: 'manageb',
        name: 'uploadsManageBlackList',
        component: ManageBlackList
      },
      {
        path: 'deals',
        name: 'uploadsDeals',
        component: uploadsDeals
      },
      {
        path: 'blackList',
        name: 'uploadsBlackList',
        component: uploadsBlackList
      },
    ]
  },
  {
    path: '/receipts',
    component: LayoutBasic, // Change the desired Layout here
    meta: {requiresAuth: true},
    children: [
      {
        path: 'receiptTemplates',
        name: 'ReceiptTemplates',
        component: ReceiptTemplates
      },
      {
        path: 'createReceipt',
        name: 'CreateReceipt',
        component: CreateReceipt
      },
      {
        path: 'receiptsStatistics',
        name: 'ReceiptsStatistics',
        component: ReceiptsStatistics
      },
    ]
  },
  {
    path: '/errors',
    component: LayoutBasic,
    meta: {requiresAuth: false},
    children: [
      {
        path: 'browser',
        component: BrowserError,
        name: 'BrowserError'
      }
    ]
  },
]

export default routes;
